import React, { MutableRefObject, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { hideSearchBar } from 'store/slices/searchBar';
import { closeNavMenu, closeProfileMenu } from 'store/slices/menu';
import { triggerCenterClick } from 'store/slices/map';
import { NavigableStepComponent, Step } from './NavigableStepComponent';
import { HelpTypes } from '../../store/slices/help';

export const SaveSpotsTutorial: React.FC<{
    onShapeChange: (shape: 'circle' | 'square') => void;
    onClickHoleRef: MutableRefObject<() => void>;
}> = ({
    onShapeChange,
    onClickHoleRef
}) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const isLoggedIn = useAppSelector((s) => s.auth.userLoginSuccess && !!s.auth.jwt);
    const [index, setIndex] = useState(0);

    const steps = useMemo<Step[]>(
        () => [
            {
                message: 'Click anywhere in the map',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    dispatch(hideSearchBar());
                    dispatch(closeProfileMenu());
                    dispatch(closeNavMenu());
                },
            },
            {
                message: 'Click the \'Add spot here\' option',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    dispatch(triggerCenterClick());
                },
                onHide: () => {
                    dispatch(triggerCenterClick());
                },
            },
            {
                message: 'You\'re not logged in, you will need a username to add your spots.',
                type: HelpTypes.INFORMATION,
                shape: 'square',
                visible: !isLoggedIn,
                onShow: () => {
                    history.push('/request-login');
                },
                onHide: () => {
                    history.push('/');
                },
            },
            {
                message: 'Now you\'re in track to create your spot. Follow the steps! some details are optional.',
                type: HelpTypes.INFORMATION,
                shape: 'square',
                visible: true,
                onShow: () => {
                    history.push('/add-spot');
                },
                onHide: () => {
                    history.push('/');
                },
            },
        ],
        [dispatch, history, isLoggedIn]
    );

    return (
        <NavigableStepComponent
            steps={steps}
            index={index}
            setIndex={setIndex}
            onClose={() => {
                setIndex(0);
                history.push('/');
            }}
            onShapeChange={onShapeChange}
            onClickHoleRef={onClickHoleRef}
        />
    );
};
